import { Node_Type } from '@wix/ricos';
import React from 'react';
export const htmlAttributesPlugin = _ => ({
  config: {},
  type: '',
  nodeViewDecorators: [htmlAttributesDecorator],
  nodeViewRenderers: {
    [Node_Type.EXTERNAL]: __ => /*#__PURE__*/React.createElement(React.Fragment, null)
  }
});
const htmlAttributesDecorator = {
  rule: node => node.type === Node_Type.EXTERNAL,
  decorate: _ref => {
    var _node$textData, _node$externalData, _node$textData2;
    let {
      node
    } = _ref;
    if (((_node$textData = node.textData) == null ? void 0 : _node$textData.text) == null) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    const props = Object.fromEntries(Object.entries(((_node$externalData = node.externalData) == null ? void 0 : _node$externalData.fields) ?? []).map(_ref2 => {
      let [k, v] = _ref2;
      return [k, v.stringValue];
    }));
    return /*#__PURE__*/React.createElement("span", props, (_node$textData2 = node.textData) == null ? void 0 : _node$textData2.text);
  }
};
//# sourceMappingURL=ricos-html-attributes-plugin.js.map